import { createContext, ReactNode, useContext, useMemo } from 'react';
import { ConfigPageResponse } from '../types/api';
import { configFallback } from '../lib/fallback';
import { useJsonApi } from '../hooks/useJsonApi';

export interface ConfigPageContextInterface {
	apiData: ConfigPageResponse;
	isFetching: boolean;
}

// eslint-disable-next-line react-refresh/only-export-components
export const CONFIG_PAGE_CONTEXT_DEFAULT: ConfigPageContextInterface = {
	apiData: configFallback,
	isFetching: false
};

const ConfigPageContext = createContext(CONFIG_PAGE_CONTEXT_DEFAULT);

// eslint-disable-next-line react-refresh/only-export-components
export function useConfigPage() {
	return useContext<ConfigPageContextInterface>(ConfigPageContext);
}

export function ConfigPageProvider({ children }: { children: ReactNode }) {
	const { isFetching, data } = useJsonApi<ConfigPageResponse>('landing');
	const apiData = useMemo(() => {
		if (data !== null && !isFetching) {
			return data;
		}
		return configFallback;
	}, [data, isFetching]);

	return (
		<ConfigPageContext.Provider
			value={{
				apiData,
				isFetching
			}}
		>
			{children}
		</ConfigPageContext.Provider>
	);
}
